import { useMutateMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { CreateCalculusConditions } from '@retail/calculus/types';
import { CustomerMarkupConditionsPost } from '@retail/customer-markup/types';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface PostConditionProps {
  assortmentIds: number[];
}

export function useMutatePostCustomerMarkupConditions(
  { assortmentIds }: PostConditionProps,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, CustomerMarkupConditionsPost[], PostConditionProps | undefined>({
    method: 'POST',
    url: (urlVariables) =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.customerMarkupConditions.getFullLinkPath(),
        searchParams: { assortmentIds: urlVariables?.assortmentIds ?? assortmentIds },
      }),
    token,
    ...queryOptions,
  });
}

interface Props extends QueryOptions {
  assortmentId: number;
}

export function useMutatePostCalculusConditions({ assortmentId, ...queryOptions }: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, CreateCalculusConditions[]>({
    method: 'POST',
    url: () =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.conditions.getFullLinkPath(),
        searchParams: { assortmentId },
      }),
    token,
    ...queryOptions,
  });
}

export const useDeleteConditions = (queryOptions: QueryOptions = {}) => {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, number[]>({
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.conditions.getFullLinkPath(),
    }),
    method: 'DELETE',
    token,
    ...queryOptions,
  });
};
